const __WEBPACK_NAMESPACE_OBJECT__ = require("eth-sig-util");